export default "__VITE_ASSET__CZRSqyc1__"